import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  dialogSurface: {
    minWidth: "280px",
    maxWidth: "320px",
    borderRadius: "12px",
    boxShadow: tokens.shadow64,
    padding: 0,
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.overflow("hidden"), // <- this is important, so header radius clips clean
  },
  headerRow: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // slightly taller for breathing room
    ...shorthands.padding("10px", "12px"),
  },
  headerText: {
    color: tokens.colorNeutralForegroundOnBrand,
  },
  closeButton: {
    color: tokens.colorNeutralForegroundOnBrand,
    minWidth: "auto",
    width: "28px",
    height: "28px",
    ...shorthands.padding(0),
  },
  body: {
    ...shorthands.padding("16px", "20px", "20px"),
  },
  bodyText: {
    color: tokens.colorNeutralForeground1,
    lineHeight: "1.45",
    fontSize: tokens.fontSizeBase300,
  },
});
